import { getCurrentInstance as s, useAttrs as i, useSlots as u } from "vue";
import n from "./index592.js";
import { isFunction as a } from "./index575.js";
const v = (o) => {
  const { emit: l } = s(), c = i(), r = u();
  return (t) => {
    const e = a(t.value) ? t.value() : t.value;
    if (e) {
      l("pick", [
        n(e[0]).locale(o.value),
        n(e[1]).locale(o.value)
      ]);
      return;
    }
    t.onClick && t.onClick({
      attrs: c,
      slots: r,
      emit: l
    });
  };
};
export {
  v as useShortcut
};
